const ScrollSectionWithMenu = {

    init() {
        this.el = $('[template="ScrollSectionWithMenu"]');
        if (!this.el.length) return;

        this.section = this.el.find('section[url]');
        this.pathname = window.location.pathname.substring(1);
        this.hash = window.location.hash;
        this.subNavButton = this.el.find('[component="SubmenuNavButton"]');
        this.left = this.section.find('div.left');
        this.leftHeight = this.section.find('div.left .wrap').height();
        this.right = this.section.find('div.right');
        this.categoryScrollList = this.left.find('li.item a[target!="_blank"]');
        this.categoryScrollDetail = this.right.find('section');

        this.bind();
    },

    bind() {
        this.categoryScrollDetail.each((i, e) => {
            let id = $(e).attr("id");
            $(e).attr("id", id.replace(this.pathname + "/", ""));
        });


        if (this.hash){
            $('html, body').animate({
                scrollTop: $(this.hash).offset().top - 100
            }, 500);
        };

        this.subNavButton.click((evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            const el = $(evt.currentTarget);

            if (!el.is('.open')) {
                this.open();
            } else {
                this.close();
            }
        });

        this.categoryScrollList.on("click", function (el) {
            ScrollSectionWithMenu.reset();
            event.preventDefault();

            let categoryUrl = $(this).attr("href").replace(this.pathname , "");

            history.pushState(null, null, categoryUrl);

            $('html, body').animate({
                scrollTop: $(categoryUrl).offset().top - 100
            }, 500);
        });
    },

    open(){
        this.subNavButton.removeClass('closing').addClass('open');
        console.log(this.leftHeight);
        this.left.addClass('open').css("max-height", this.leftHeight);
    },

    close(){
        this.subNavButton.removeClass('open').addClass('closing');
        this.left.removeClass('open').removeAttr('style');
    },

    reset(){
        this.subNavButton.removeClass('open').addClass('closing');
        this.left.removeClass('open').removeAttr('style').css("transition", "none");
    }
}

export default ScrollSectionWithMenu;